import { Applicazioni } from "../types/types";

export class VariabiliConfig {
    client_id: string;
    title: string;
    api_url: string;
    base_url: string;
    application: number;
    sviluppo: boolean = false;
    versione: string;
    enviroment: string;
}
export function GetConfiguration() {
    let ret: VariabiliConfig = new VariabiliConfig();
    let suffix = "";
    if (window.location.host.includes("wki-")) {
        suffix = "wki-";
    }
    //Mappo i siti di production e di Test
    if (window.location.host.includes("consultool.sixtemacloud.it") || window.location.host.includes("iforf_test.sixtemacloud.it")) {
        ret.client_id = "dbe4a355-f85e-4911-96ea-36330e2cbef3";   // è il guid di iforf
        ret.title = "ConsulTool";
        if (window.location.host.includes("wki-")) {
            ret.title = "SimulTax"
        }
        ret.api_url = `${process.env.REACT_APP_BASE_URL}/api`;        
        // ret.api_url = "https://" + suffix + `${process.env.REACT_APP_CUSTOM_IFORF_URL}/api`;        
        ret.application = Applicazioni.Home;
        ret.base_url = "https://" + suffix + `${process.env.REACT_APP_CUSTOM_URL}`;
    }
    // else if (window.location.host.includes("convsrl.sixtemacloud.it")) {
    //     // console.log('sono in app2 conv');
    //     ret.client_id = "8db6b799-2a17-490d-804a-20d51a40d3b3";
    //     ret.title = "Convenienza Srl";
    //     if (window.location.host.includes("wki-")) {
    //         ret.title = "Simulazione SRL"
    //     }
    //     // ret.api_url = "https://convsrl.sixtemacloud.it/api";
    //     ret.api_url = `${process.env.REACT_APP_BASE_CONV_URL}/api`;
    //     ret.application = Applicazioni.ConvSrl;
    //     // ret.base_url = "https://" + suffix + "convsrl.sixtemacloud.it/";
    //     ret.base_url = "https://" + suffix + `${process.env.REACT_APP_CUSTOM_CONV_URL}`;
    // }
    else { 
        //sviluppo
        ret.title = "ConsulTool";
        ret.client_id = "dbe4a355-f85e-4911-96ea-36330e2cbef3"; 
        ret.api_url = `${process.env.REACT_APP_API_PROXY}`;
        ret.application = Applicazioni.Home;  
        ret.sviluppo = false;
        ret.base_url = `${process.env.REACT_APP_BASE_URL}`;
    }
    ret.enviroment = `${process.env.REACT_APP_ENVIROMENT}`;
    ret.versione = `${process.env.REACT_APP_VERSION}`;
    return ret;
}